// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IconToggle-module__icon___Xsj3U{padding:0;vertical-align:top;top:6px;left:8px}
`, "",{"version":3,"sources":["webpack://./node_modules/mintel-react-ui/dist/package/index3.css"],"names":[],"mappings":"AAAA,iCAAiC,SAAS,CAAC,kBAAkB,CAAC,OAAO,CAAC,QAAQ","sourcesContent":[".IconToggle-module__icon___Xsj3U{padding:0;vertical-align:top;top:6px;left:8px}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
